import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { TeamMember } from '../types';

type UseTeamMembersOptions = { includeDeleted?: boolean };

export function useTeamMembers(opts: UseTeamMembersOptions = {}) {
  const includeDeleted = !!opts.includeDeleted;
  const filter = includeDeleted
    ? "account_status = 'deleted'"
    : "account_status != 'deleted'";
  return useQuery({
    queryKey: ['team-members', { deleted: includeDeleted }],
    queryFn: async (): Promise<TeamMember[]> =>
      pb.collection('team_members').getFullList<TeamMember>({
        sort: 'created',
        filter,
      }),
    staleTime: 0,
  });
}

/** @deprecated Use useTeamMembers */
export const useApproachers = useTeamMembers;
